import { TRANSCEIVERS_TYPES } from "../settings"
import { store } from "../store/store"

export const isGPON = () => {
    const state = store.getState()
    return state.calculator.values.transceiver_1?.val === TRANSCEIVERS_TYPES.GPON
}

export const isXGSPON = () => {
    const state = store.getState()
    return state.calculator.values.transceiver_1?.val === TRANSCEIVERS_TYPES.XGS_PON
}

export const isComboPON = () => {
    const state = store.getState()
    return state.calculator.values.transceiver_1?.val === TRANSCEIVERS_TYPES.COMBO_PON
}

export const agingMarginEnable = () => {
    const state = store.getState();
    return state.calculator.values.aging_margin_enable?.val
}

export const notEmptyVal = (val: any) => {
    return val !== "" && val !== null && val !== undefined;
}

export const getMarginRequirement = (state: any) => {
    return +state?.margin_requirement?.val
}